<template>
    <b-container fluid id="table">
        <b-row class="d-flex justify-content-center text-center">
            <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
                <input class="form-control ShifokrSverka" type="date" v-model="datas.date1" />
            </b-col>
            <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
                <input class="form-control ShifokrSverka" type="date" v-model="datas.date2" />
            </b-col>
            <b-col lg="4" xs="4" md="4" xl="4" class="my-3">
                <v-select :options="names" v-model="datas.user_id" :reduce="option => option.id" label="user_name"
                    :placeholder="$t('ходимни танланг...')" />
            </b-col>
            <b-col lg="2" xs="2" md="2" xl="2" class="my-3">
                <button type="button" class="btn text-white" style="background: #195FB0; width: 130px; font-size: 14px"
                    @click="Send()">
                    <img src="../../../public/Vector.png" alt="" style="margin-right: 5px" />
                    {{ $t("Кўриш") }}
                </button>
                <b-button class="navbarBtnDanger ml-3" variant="danger" @click="cancel()">
                    <b-icon icon="x-circle-fill"></b-icon>
                </b-button>
            </b-col>
        </b-row>
        <div>
            <table class="table table-bordered table-sm table-striped">
                <tr class="bg-dark text-white">
                    <th>№</th>
                    <th>{{ $t("Вақт") }}</th>
                    <th>{{ $t("Ходим ФИО") }}</th>
                    <th>{{ $t("Қўйилган балл") }}</th>
                    <th>{{ $t("Изоҳ") }}</th>
                </tr>
                <tr v-for="(item, index) in items" :key="index">
                    <td>
                        {{ index + 1 }}
                    </td>
                    <td>
                        {{ item.time | dateFormatDD }}
                    </td>
                    <td>
                        {{ item.users.user_name }}
                    </td>
                    <td>
                        <span>{{ item.reyting_ball }}</span>
                    </td>
                    <td>
                        {{ item.comment }}
                    </td>
                </tr>
            </table>
        </div>
    </b-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
    data() {
        return {
            datas: {
                date1: new Date().toISOString().slice(0, 8) + "01",
                date2: new Date().toISOString().slice(0, 10),
                user_id: null
            },
            names: [],
            items: []
        };
    },
    filters: {
        dateFormatDD: function (date) {
            if (date != null) {
                return moment(new Date(date * 1000)).format("DD.MM.YYYY HH:mm");
            } else {
                return "";
            }
        }
    },
    created() {
        let self = this;
        if (localStorage.getItem("direct") != null) {
            self.datas.date1 = JSON.parse(localStorage.getItem("direct")).date1;
            self.datas.date2 = JSON.parse(localStorage.getItem("direct")).date2;
            self.datas.direct_id = JSON.parse(
                localStorage.getItem("direct")
            ).direct_id;
            self.Send();
        } else {
            self.datas.date1 = new Date().toISOString().slice(0, 10);
            self.datas.date2 = new Date().toISOString().slice(0, 10);
        }
    },
    methods: {
        Send() {
            let self = this;
            var datas = {
                datetime1: parseInt(
                    new Date(self.datas.date1)
                        .valueOf()
                        .toString()
                        .slice(0, 10)
                ),
                datetime2:
                    parseInt(
                        new Date(self.datas.date2)
                            .valueOf()
                            .toString()
                            .slice(0, 10)
                    ) + 86399,
                user_id: self.datas.user_id
            };
            axios({
                method: "post",
                url: "hisobot/reyting_hisobot",
                data: datas
            }).then(function (res) {
                if(!res.error){
                    self.items = (res.data.data);
                }
            });
        },
        getDoctor() {
            let self = this;
            axios({
                method: "get",
                url: "/user/all"
            }).then(res => {
                for (let index = 0; index < res.data.data.length; index++) {
                    const element = res.data.data[index];
                    if (element.role == "Loborant" || element.role == "Shifokor" || element.role == "Hamshira") {
                        self.names.push(element);
                    }
                }
            });
        },
        cancel() {
            window.close();
        }
    },
    mounted() {
        this.getDoctor();
    }
};
</script>

<style scoped>
#table {
    height: 100vh;
    width: 99% !important;
}

.table {
    margin: 0px 0px !important;
}

label,
td,
th,
tr {
    font-family: "Times New Roman", Times, serif;
    font-weight: bolder;
    text-transform: capitalize;
    font-size: 15px;
    height: 30px !important;
    text-align: center;
}

.navbarBtnDanger {
    border: 1px solid #fff;
    /* box-shadow: 5px 8px 10px rgba(176, 25, 25, 0.3); */
    background: #e80a18;
    border-radius: 8px;
}

.ShifokrSverka {
    border-radius: 3px;
    background: #fff;
    border: 1px solid rgb(210, 210, 210);
}

.reds {
    color: red;
}

th {
    color: #195fb0;
    background-color: #f4f7fb;
}
</style>